import React, { useEffect, useState } from "react";
import cx from "classnames";

import { useDebouncedEffect } from "@hooks/debounceEffect";
import { useStore } from "@store/store";
import Header from "@components/header";
import Loader from "@components/loader";
import {
	getFilter,
	setFilter,
	removeFilter,
	getUserData,
} from "@utils/commonFunctions";
import { innerPageStyle } from "@utils/commonStyles";
import {
	GET_MAPCOCKPIT,
	GET_MAPCOCKPIT_SUCCESS,
	GET_MAPCOCKPIT_FAILURE,
} from "@utils/actionTypes";
import { getApi } from "@services/axios";
import Filter from "./filter";

import Map from "./map";
import { MapStyle } from "./style";
import { get_token } from "./cockpitAPI/getToken";
import { get_vehicle_location } from "./cockpitAPI";

function MapCockpit(props) {
	const classes = innerPageStyle();
	const filter = getFilter("mapcockpitFilter", true);
	const mapClasses = MapStyle();
	const [filterData, setFilterData] = useState({
		jobType: filter ? filter.jobType : [],
		cargoType: filter ? filter.cargoType : [],
		cto: filter ? filter.cto : [],
	});
	const [updateFilter, setUpdateFilter] = useState({});
	const [openFilter, setOpenFilter] = useState(false);
	const [search, setSearch] = useState(filter ? filter.search : "");
	const [rego, setRego] = useState(true);
	const [showJobs, setShowJobs] = useState(false);
	const [getState, setState] = useState({
		right: false,
	});
	const [state, dispatch] = useStore();

	// API calling to get mapcockpit data
	const getMapcockpit = () => {
		const params = {
			...(!!search ? { search } : {}),
			filter: {
				...(!!filterData.jobType.length
					? { jobTypeId: filterData.jobType }
					: {}),
				...(!!filterData.cargoType.length
					? { cargoTypeId: filterData.cargoType }
					: {}),
				...(!!filterData.cto.length ? { ctoId: filterData.cto } : {}),
			},
		};
		dispatch({ type: GET_MAPCOCKPIT });
		getApi("mapCockpits", { params }, true)
			.then((response) => {
				dispatch({ type: GET_MAPCOCKPIT_SUCCESS, payload: response?.data?.data?.rows });
			})
			.catch((error) => {
				dispatch({
					type: GET_MAPCOCKPIT_FAILURE,
					payload: error?.response?.data,
				});
			});
	};

	useEffect(() => {
		setRego(localStorage.getItem("ShowRego") === "true" ? true : false);
		const interval = setInterval(() => {
			if (getUserData()?.isMapCockpitAutoRefresh) {
				window.location.reload();
			}
		}, 900000);

		return () => {
			removeFilter("mapcockpitFilter");
			clearInterval(interval);
		};
	}, []);

	useEffect(() => {
		getMapcockpit();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateFilter]);

	useEffect(() => {
		const interval = setInterval(async () => {
		if(!!state.mapCockpit?.mapcockpitData.length) {
			try {
				const token = await get_token();
				const newData = await Promise.all(
				state.mapCockpit?.mapcockpitData.map(async (item) => {
					if (!!item.trucks.vehicleNumber) {
						try {
							const response = await get_vehicle_location(
							token.data,
							item.trucks.vehicleNumber
							);
							item.jobRunsheets[0].latitude = response?.Latitude;
							item.jobRunsheets[0].longitude = response?.Longitude;
						} catch (error) {
							console.log('error', error);
						}
					}
					return item;
				})
				);
				dispatch({ type: GET_MAPCOCKPIT_SUCCESS, payload: newData });
			} catch (error) {
				console.log('error', error);
			}
		}
		}, 300000);
		return () => clearInterval(interval);
	}, [state.mapCockpit?.mapcockpitData, dispatch]);

	useDebouncedEffect(
		() => {
			if (!openFilter) getMapcockpit();
		},
		1000,
		[search]
	);
	const handleSearch = (event) => {
		setSearch(event.target.value.trimStart());
		setFilter(
			"mapcockpitFilter",
			{
				...filterData,
				search: event.target.value.trimStart(),
			},
			true
		);
	};
	const handleFilter = (event) => {
		const { name, value } = event.target;
		setFilterData({
			...filterData,
			[name]: value,
		});
		if (!openFilter) {
			setUpdateFilter(filterData);
			setFilter(
				"mapcockpitFilter",
				{
					...filterData,
					[name]: value,
					search,
				},
				true
			);
		}
	};

	const handleSubmit = (anchor) => {
		setUpdateFilter(filterData);
		setFilter("mapcockpitFilter", { ...filterData, search }, true);
		closeFilerPopup();
	};
	const handleReset = (anchor) => {
		removeFilter("mapcockpitFilter");
		setSearch("");
		setRego(true);
		setShowJobs(false);
		setFilterData({
			jobType: [],
			cargoType: [],
			cto: [],
		});
		setUpdateFilter({
			jobType: [],
			cargoType: [],
			cto: [],
		});
		closeFilerPopup();
	};
	const openFilterPopup = () => {
		document.body.classList.toggle("open-filter");
		setOpenFilter(true);
	};

	const closeFilerPopup = () => {
		document.body.classList.remove("open-filter");
		setOpenFilter(false);
	};
	const handleRego = (e) => {
		setRego(e.target.checked);
		setFilter("ShowRego", e.target.checked);
		localStorage.setItem("ShowRego", e.target.checked);
	};
	const handleShowJobs = (e) => {
		setShowJobs(e.target.checked);
	};
	// To open drawer of jobs
	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event &&
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}
		setState({ ...getState, [anchor]: open });
	};
	return (
		<>
			<Header />

			<div className={cx(classes.innerPageWrapper, mapClasses.MapWrapper)}>
				<Loader loading={state.mapCockpit?.loadingMapcockpit} />

				<div className="map-page inner-page wrapper">
					<Filter
						handleFilter={handleFilter}
						filterData={filterData}
						openFilterPopup={openFilterPopup}
						closeFilerPopup={closeFilerPopup}
						handleSubmit={handleSubmit}
						handleReset={handleReset}
						handleSearch={handleSearch}
						search={search}
						rego={rego}
						handleRego={handleRego}
						showJobs={showJobs}
						handleShowJobs={handleShowJobs}
						toggleDrawer={toggleDrawer}
						getState={getState}
					/>

					<Map openFilter={openFilter} rego={rego} showJobs={showJobs} />
				</div>
			</div>
		</>
	);
}

export default MapCockpit;
